import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => {
  return ({
    headerWrapper: {
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '24px 40px',
      height: '100%'
    },
    title: {
      color: '#335977',
      fontSize: '30px',
      fontWeight: 'bold',
      margin: '0 5px 5px 0'
    },
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    },
    stepperContainer: {
      boxShadow: '0px 2px 10px #3F434714',
      margin: '24px 40px',
      padding: '1px 20px 20px',
    },
    formContainer: {
      boxShadow: '0px 2px 10px #3F434714',
      margin: '24px 40px',
      padding: '20px'
    },
    formHeading: {
      color: '#F37320',
      backgroundColor: '#F7F7F7',
      fontSize: '14px',
      fontWeight: 600,
    },
    listKey: {
      fontSize: '12px',
      color: '#939497'
    },
    listValue: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#545455',
      wordBreak: 'break-all'
    },
    listSubValue: {
      fontSize: '14px',
      color: '#545455',
      backgroundColor: '#F5F5F5',
      borderRadius: '2px',
      padding: '0px 4px'
    },
    applicationFile: {
      width: '30%',
      maxWidth: '220px',
      minWidth: '180px',
      margin: '20px 10px',
      minHeight: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      border: '1px dashed #70707089',
      opacity: 1,
      backgroundColor: '#F5F5F5',
      padding: '15px 20px',
    },
    fileHelperText: {
      color: '#545456',
      fontSize: '12px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    modalKey: {
      fontSize: '18px',
      color: '#000000',
      opacity: 0.7
    },
    modalValue: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#000000',
      opacity: 0.7
    },
    siteDetail: {
      fontSize: '15px',
      color: '#545455'
    },
    fileName: {
      cursor: 'pointer',
      color: '#545456',
      textAlign: 'center',
      fontSize: '12px',
      marginTop: 20,
      wordBreak: 'break-all',
      minWidth: '185px'
    },
    downloadIcon: {
      verticalAlign: 'middle',
      marginRight: '5px',
      width: '18px'
    },
    link: {
      color: '#F37320',
      fontSize: '16px'
    },
    siteField: {
      height: '60px'
    },
    timelineWrapper: {
      maxHeight: '400px',
      overflowY: 'auto'
    },
    timelineText: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '14px',
      color: '#F37320',
      cursor: 'pointer'
    },
    timelineTitle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#535050'
    },
    timelineConnector: {
      backgroundColor: '#F37320',
      opacity: '50%'
    },
    timelineLeftMainText: {
      fontWeight: 'bold',
      fontSize: '16px',
      color: '#535050',
      textAlign: 'left'
    },
    timelineLeftText: {
      fontSize: '12px',
      color: '#535050',
      opacity: '54%',
      textAlign: 'left'
    },
    timelineRightMainText: {
      color: '#535050',
      fontSize: '14px'
    },
    timelineRightText: {
      color: '#F37320',
      fontSize: '12px',
      wordBreak: 'break-word'
    },
    dotSeparator: {
      backgroundColor: '#F37320',
      width: '5px',
      height: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    customPaper: {
      maxWidth: '650px'
    },
  })
})

export { useStyles }
